import { createContext } from "react";

export type Theme = {
  primaryColor: string;
  secondaryColor: string;
};

export const initialValue: Theme = {
  primaryColor: "#55BEE1",
  secondaryColor: "#D3337F",
};

export const ThemeContext = createContext(initialValue);

export const { Provider: ThemeProvider, Consumer: ThemeConsumer } =
  ThemeContext;
